// src/components/Gallery.js
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import T1 from "../assets/images/gallery/21-tach/1.jpg";
import T2 from "../assets/images/gallery/21-tach/2.jpg";
import T3 from "../assets/images/gallery/21-tach/3.jpg";
import T4 from "../assets/images/gallery/21-tach/4.jpg";
import A1 from "../assets/images/gallery/aessa/1.jpg";
import A2 from "../assets/images/gallery/aessa/2.jpg";
import A3 from "../assets/images/gallery/aessa/3.jpg";
import A4 from "../assets/images/gallery/aessa/4.jpg";
import A5 from "../assets/images/gallery/aessa/5.jpg";
import A6 from "../assets/images/gallery/aessa/6.jpg";
import A7 from "../assets/images/gallery/aessa/7.jpg";
import A8 from "../assets/images/gallery/aessa/8.jpg";
import A9 from "../assets/images/gallery/aessa/9.jpg";
import A10 from "../assets/images/gallery/aessa/10.jpg";
import A11 from "../assets/images/gallery/aessa/11.jpg";
import S1 from "../assets/images/gallery/astro/1.png";
import S2 from "../assets/images/gallery/astro/2.png";
import S3 from "../assets/images/gallery/astro/3.png";
import S4 from "../assets/images/gallery/astro/4.png";
import S5 from "../assets/images/gallery/astro/5.png";
import S6 from "../assets/images/gallery/astro/6.png";
import S7 from "../assets/images/gallery/astro/7.png";
import S8 from "../assets/images/gallery/astro/8.png";
import D1 from "../assets/images/gallery/diib/1.jpg";
import D2 from "../assets/images/gallery/diib/2.jpg";
import D3 from "../assets/images/gallery/diib/3.jpg";
import D4 from "../assets/images/gallery/diib/4.jpg";
import D5 from "../assets/images/gallery/diib/5.jpg";
import D6 from "../assets/images/gallery/diib/6.jpg";
import E1 from "../assets/images/gallery/em/1.jpg";
import E2 from "../assets/images/gallery/em/2.jpg";
import E3 from "../assets/images/gallery/em/3.jpg";
import E4 from "../assets/images/gallery/em/4.jpg";
import E5 from "../assets/images/gallery/em/5.jpg";
import E6 from "../assets/images/gallery/em/6.jpg";
import E7 from "../assets/images/gallery/em/7.jpg";
import F1 from "../assets/images/gallery/furelise/1.jpg";
import F2 from "../assets/images/gallery/furelise/2.jpg";
import F3 from "../assets/images/gallery/furelise/3.jpg";
import F4 from "../assets/images/gallery/furelise/4.jpg";
import F5 from "../assets/images/gallery/furelise/5.jpg";
import F6 from "../assets/images/gallery/furelise/6.jpg";
import F7 from "../assets/images/gallery/furelise/7.jpg";
import F8 from "../assets/images/gallery/furelise/8.jpg";
import F9 from "../assets/images/gallery/furelise/9.jpg";
import F10 from "../assets/images/gallery/furelise/10.jpg";
import F11 from "../assets/images/gallery/furelise/11.jpg";
import F12 from "../assets/images/gallery/furelise/12.jpg";
import F13 from "../assets/images/gallery/furelise/13.jpg";
import J1 from "../assets/images/gallery/jntyy/1.jpg";
import J2 from "../assets/images/gallery/jntyy/2.jpg";
import J3 from "../assets/images/gallery/jntyy/3.jpg";
import J4 from "../assets/images/gallery/jntyy/4.jpg";
import J5 from "../assets/images/gallery/jntyy/5.jpg";
import J6 from "../assets/images/gallery/jntyy/6.jpg";
import J7 from "../assets/images/gallery/jntyy/7.jpg";
import K1 from "../assets/images/gallery/klass-a/1.jpg";
import K2 from "../assets/images/gallery/klass-a/2.jpg";
import K3 from "../assets/images/gallery/klass-a/3.jpg";
import K4 from "../assets/images/gallery/klass-a/4.jpg";
import K5 from "../assets/images/gallery/klass-a/5.jpg";
import K6 from "../assets/images/gallery/klass-a/6.jpg";
import P1 from "../assets/images/gallery/kpv/1.png";
import P2 from "../assets/images/gallery/kpv/2.png";
import P3 from "../assets/images/gallery/kpv/3.png";
import P4 from "../assets/images/gallery/kpv/4.png";
import P5 from "../assets/images/gallery/kpv/5.png";
import P6 from "../assets/images/gallery/kpv/6.png";
import P7 from "../assets/images/gallery/kpv/7.png";
import P8 from "../assets/images/gallery/kpv/8.png";
import P9 from "../assets/images/gallery/kpv/9.png";
import P10 from "../assets/images/gallery/kpv/10.png";
import L1 from "../assets/images/gallery/lmltm/1.jpg";
import L2 from "../assets/images/gallery/lmltm/2.jpg";
import L3 from "../assets/images/gallery/lmltm/3.jpg";
import L4 from "../assets/images/gallery/lmltm/4.jpg";
import L5 from "../assets/images/gallery/lmltm/5.jpg";
import L6 from "../assets/images/gallery/lmltm/6.jpg";
import O1 from "../assets/images/gallery/loun/1.jpg";
import O2 from "../assets/images/gallery/loun/2.jpg";
import O3 from "../assets/images/gallery/loun/3.jpg";
import O4 from "../assets/images/gallery/loun/4.jpg";
import O5 from "../assets/images/gallery/loun/5.jpg";
import O6 from "../assets/images/gallery/loun/6.jpg";
import M1 from "../assets/images/gallery/morpho/1.png";
import M2 from "../assets/images/gallery/morpho/2.png";
import M3 from "../assets/images/gallery/morpho/3.png";
import M4 from "../assets/images/gallery/morpho/4.png";
import M5 from "../assets/images/gallery/morpho/5.png";
import M6 from "../assets/images/gallery/morpho/6.png";
import M7 from "../assets/images/gallery/morpho/7.png";
import M8 from "../assets/images/gallery/morpho/8.png";
import M9 from "../assets/images/gallery/morpho/9.png";
import M10 from "../assets/images/gallery/morpho/10.png";
import M11 from "../assets/images/gallery/morpho/11.png";
import N1 from "../assets/images/gallery/only/1.png";
import N2 from "../assets/images/gallery/only/2.png";
import N3 from "../assets/images/gallery/only/3.png";
import N4 from "../assets/images/gallery/only/4.png";
import N5 from "../assets/images/gallery/only/5.png";
import N6 from "../assets/images/gallery/only/6.png";
import N7 from "../assets/images/gallery/only/7.png";
import U1 from "../assets/images/gallery/pakkun/1.jpg";
import U2 from "../assets/images/gallery/pakkun/2.jpg";
import U3 from "../assets/images/gallery/pakkun/3.jpg";
import U4 from "../assets/images/gallery/pakkun/4.jpg";
import U5 from "../assets/images/gallery/pakkun/5.jpg";
import U6 from "../assets/images/gallery/pakkun/6.jpg";
import U7 from "../assets/images/gallery/pakkun/7.jpg";
import R1 from "../assets/images/gallery/raid/1.png";
import R2 from "../assets/images/gallery/raid/2.png";
import R3 from "../assets/images/gallery/raid/3.png";
import R4 from "../assets/images/gallery/raid/4.png";
import R5 from "../assets/images/gallery/raid/5.png";
import R6 from "../assets/images/gallery/raid/6.png";
import R7 from "../assets/images/gallery/raid/7.png";
import R8 from "../assets/images/gallery/raid/8.png";
import X1 from "../assets/images/gallery/x7kira/1.jpg";
import X2 from "../assets/images/gallery/x7kira/2.jpg";
import X3 from "../assets/images/gallery/x7kira/3.jpg";
import X4 from "../assets/images/gallery/x7kira/4.jpg";
import X5 from "../assets/images/gallery/x7kira/5.jpg";
import X6 from "../assets/images/gallery/x7kira/6.jpg";
import X7 from "../assets/images/gallery/x7kira/7.jpg";
import X8 from "../assets/images/gallery/x7kira/8.jpg";
import Y1 from "../assets/images/gallery/youss45/1.png";
import Y2 from "../assets/images/gallery/youss45/2.png";
import Y3 from "../assets/images/gallery/youss45/3.png";
import Y4 from "../assets/images/gallery/youss45/4.png";
import Y5 from "../assets/images/gallery/youss45/5.png";
import Y6 from "../assets/images/gallery/youss45/6.png";
import Y7 from "../assets/images/gallery/youss45/7.png";
import Y8 from "../assets/images/gallery/youss45/8.png";
import Y9 from "../assets/images/gallery/youss45/9.png";
import Y10 from "../assets/images/gallery/youss45/10.png";
import Y11 from "../assets/images/gallery/youss45/11.png";

const ARTISTS = [
  {
    name: "21 Tach",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [T1, T2, T3, T4]
  },
  {
    name: "Aessa",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [A1, A2, A3, A4, A5, A6, A7, A8, A9, A10, A11]
  },
  {
    name: "Astro",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [S1, S2, S3, S4, S5, S6, S7, S8]
  },
  {
    name: "Diib",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [D1, D2, D3, D4, D5, D6]
  },
  {
    name: "Em",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [E1, E2, E3, E4, E5, E6, E7]
  },
  {
    name: "Für Elise",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [F1, F2, F3, F4, F5, F6, F7, F8, F9, F10, F11, F12, F13]
  },
  {
    name: "JNTYY",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [J1, J2, J3, J4, J5, J6, J7]
  },
  {
    name: "Klass A",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [K1, K2, K3, K4, K5, K6]
  },
  {
    name: "KPV",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [P1, P2, P3, P4, P5, P6, P7, P8, P9, P10]
  },
  {
    name: "LMLTM",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [L1, L2, L3, L4, L5, L6]
  },
  {
    name: "Loun",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [O1, O2, O3, O4, O5, O6]
  },
  {
    name: "Morpho",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [M1, M2, M3, M4, M5, M6, M7, M8, M9, M10, M11]
  },
  {
    name: "Only",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [N1, N2, N3, N4, N5, N6, N7]
  },
  {
    name: "Pakkun",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [U1, U2, U3, U4, U5, U6, U7]
  },
  {
    name: "Raid",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [R1, R2, R3, R4, R5, R6, R7, R8]
  },
  {
    name: "x7Kira",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [X1, X2, X3, X4, X5, X6, X7, X8]
  },
  {
    name: "Youss45",
    platforms: { instagram: "#", youtube: "#", spotify: "#" },
    gallery: [Y1, Y2, Y3, Y4, Y5, Y6, Y7, Y8, Y9, Y10, Y11]
  }
];

/* ===== helpers ===== */
const toItems = (artists) =>
  artists.flatMap((artist) =>
    artist.gallery.map((src) => ({ id: String(src), src, artist }))
  );

const shuffle = (arr) => {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

/* ==== tiny in-view hook: mount image only when near viewport ==== */
function useInView(rootMargin = "300px") {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setInView(true)),
      { rootMargin }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [rootMargin]);
  return { ref, inView };
}

/* ==== card (same UI, smarter loading) ==== */
const MIN_SPINNER_MS = 600; // feel-good minimum; raise if you want longer animation
// If actual load takes longer than MIN_SPINNER_MS, we show the image immediately on load.

const ImageCard = React.memo(function ImageCard({
  item,
  index,
  loadedMap,
  onLoaded,
  onError,
  eager = false,
}) {
  const { ref, inView } = useInView("400px");

  const state = loadedMap[item.id];

  const [mountedAt] = useState(
    () => performance.now()
  );

  const handleLoad = () => {
    const elapsed =
      performance.now() - mountedAt;

    const wait =
      Math.max(
        0,
        MIN_SPINNER_MS - elapsed
      );

    setTimeout(
      () => onLoaded(item.id),
      wait
    );
  };

  return (
    <article
      ref={ref}
      className={`gallery-card gallery-card-${
        (index % 6) + 1
      }`}
    >

      {!state && (
        <div className="gallery-loader-wrapper">
          <div className="gallery-loader" />
        </div>
      )}

      {state !== "error" &&
        inView && (
          <img
            src={item.src}
            alt={`${item.artist.name} — LHANGAR`}
            onLoad={handleLoad}
            onError={() =>
              onError(item.id)
            }
            className={
              state
                ? "gallery-photo loaded"
                : "gallery-photo"
            }
            loading={
              eager
                ? "eager"
                : "lazy"
            }
            decoding="async"
          />
        )}

      {state === "error" && (
        <div className="gallery-error">
          Image unavailable
        </div>
      )}

      <div className="gallery-card-overlay">

        <div className="gallery-card-index">
          {String(index + 1).padStart(
            2,
            "0"
          )}
        </div>

        <div className="gallery-card-info">

          <small>
            LHANGAR ARCHIVE
          </small>

          <h3>
            {item.artist.name}
          </h3>

          <span>
            VIEW MOMENT ↗
          </span>

        </div>

      </div>

    </article>
  );
});

/* ==== main ==== */
export default function Gallery() {
  const allItems = useMemo(() => shuffle(toItems(ARTISTS)), []);
  const [query, setQuery] = useState("");
  const [visible, setVisible] = useState(12); // show a bit more upfront
  const [loaded, setLoaded] = useState({}); // map by item.id

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q
      ? allItems.filter((i) => i.artist.name.toLowerCase().includes(q))
      : allItems;
  }, [allItems, query]);

  // throttle scroll handler using rAF so it doesn't spam setState
  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 250
        ) {
          setVisible((v) => Math.min(v + 10, filtered.length));
        }
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [filtered.length]);

  useEffect(() => {
    setVisible((v) => Math.min(Math.max(12, v), filtered.length));
  }, [filtered.length]);

  const markLoaded = (id) => setLoaded((m) => ({ ...m, [id]: true }));
  const markError = (id) => setLoaded((m) => ({ ...m, [id]: "error" }));

return (
  <>
    <Helmet>

      <title>
        Gallery — LHANGAR
      </title>

      <meta
        name="description"
        content="Explore exclusive moments captured throughout LHANGAR cyphers, performances and artist sessions."
      />

    </Helmet>

    <main className="gallery-page">

      <section className="gallery-hero">

        <div className="gallery-container">

          <div className="gallery-topline">

            <div>
              <span>ARCHIVE</span>
              <small>
                LHANGAR / GALLERY
              </small>
            </div>

            <span className="gallery-count">
              {filtered.length} MOMENTS
            </span>

          </div>

          <div className="gallery-hero-content">

            <h1>
              MOMENTS
              <span>
                THAT STAY.
              </span>
            </h1>

            <p>
              More than photographs.
              These are moments from
              LHANGAR cyphers, artists,
              backstage sessions and the
              culture surrounding the
              movement.
            </p>

          </div>

          <div className="gallery-filter">

            <span>FILTER BY ARTIST</span>

            <div className="gallery-search">

              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <circle
                  cx="11"
                  cy="11"
                  r="7"
                />

                <path d="m20 20-3.5-3.5" />
              </svg>

              <input
                placeholder="Search artist..."
                value={query}
                onChange={(e) =>
                  setQuery(
                    e.target.value
                  )
                }
                aria-label="Filter by artist name"
              />

              {query && (
                <button
                  type="button"
                  onClick={() =>
                    setQuery("")
                  }
                >
                  ×
                </button>
              )}

            </div>

          </div>

        </div>

      </section>

      <section className="gallery-feed">

        <div className="gallery-container">

          {filtered.length > 0 ? (

            <div className="gallery-masonry">

              {filtered
                .slice(0, visible)
                .map(
                  (item, i) => (
                    <ImageCard
                      key={item.id}
                      item={item}
                      index={i}
                      loadedMap={
                        loaded
                      }
                      onLoaded={
                        markLoaded
                      }
                      onError={
                        markError
                      }
                      eager={
                        i < 6
                      }
                    />
                  )
                )}

            </div>

          ) : (

            <div className="gallery-empty">

              <span>NO RESULTS</span>

              <h2>
                No artist found.
              </h2>

              <button
                onClick={() =>
                  setQuery("")
                }
              >
                CLEAR SEARCH
              </button>

            </div>

          )}

        </div>

      </section>

    </main>
  </>
);
}
